module.exports = __webpack_public_path__ + "img/1-lg.d89893bd.jpg";